import { PlanTable } from "@/components/plans/plan-table"

export default function PlansPage() {
  return <PlanTable />
}
